import { useCallback, useRef } from 'react';

const LONG_CLICK_DURATION = 300;

function useLongClick() {
  const longClickTimeout = useRef<NodeJS.Timeout | null>(null);
  const longClickCallback = useRef<(() => void) | null>(null);

  const beginLongClick = useCallback((newOnLongClick: () => void) => {
    longClickCallback.current = () => newOnLongClick();
    longClickTimeout.current = setTimeout(() => {
      if (longClickCallback.current) {
        longClickCallback.current();
      }
    }, LONG_CLICK_DURATION);
  }, []);

  const cancelLongClick = useCallback(() => {
    longClickTimeout.current && clearTimeout(longClickTimeout.current);
    longClickTimeout.current = null;
  }, []);

  return { beginLongClick, cancelLongClick };
}

export default useLongClick;
